import React from 'react';
import { ArrowRight, Mail } from 'lucide-react';

const Footer = ({ onDownloadClick }) => {
  return (
    <footer style={{
      background: '#000000',
      borderTop: '1px solid rgba(255, 255, 255, 0.25)',
      padding: '60px 7.6923%'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto'
      }}>
        <div className="footer-grid" style={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr',
          gap: '60px',
          marginBottom: '60px'
        }}>
          <div>
            <div style={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '16px',
              letterSpacing: '-0.5px'
            }}>
              UNIVERSE ENGINE
            </div>
            <p style={{
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: 1.5,
              color: 'rgba(255, 255, 255, 0.85)',
              maxWidth: '400px'
            }}>
              A mathematical framework where causality flows both ways, and the boundary conditions of time itself determine everything in between.
            </p>
          </div>

          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '16px'
            }}>
              Links
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <a href="#paradigm" style={{
                color: '#4D4D4D',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
              onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
                Theory
              </a>
              <a href="#proof" style={{
                color: '#4D4D4D',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
              onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
                Predictions
              </a>
              <a href="#implications" style={{
                color: '#4D4D4D',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
              onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
                Implications
              </a>
            </div>
          </div>

          <div>
            <h4 style={{
              fontSize: '18px',
              fontWeight: 600,
              color: '#FFFFFF',
              marginBottom: '16px'
            }}>
              Resources
            </h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <button
                onClick={onDownloadClick}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#4D4D4D',
                  textDecoration: 'none',
                  fontSize: '16px',
                  cursor: 'pointer',
                  padding: 0,
                  textAlign: 'left',
                  transition: 'color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
                onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
                Download Paper
              </button>
              <a href="#discussion" style={{
                color: '#4D4D4D',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
              onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
                Discussion Forum
              </a>
              <a href="#contact" style={{
                color: '#4D4D4D',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#00FFD1'}
              onMouseLeave={(e) => e.target.style.color = '#4D4D4D'}>
                Contact
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom" style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.25)',
          paddingTop: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#4D4D4D',
            margin: 0
          }}>
            © 2025 Universe Engine. The Future Selects.
          </p>
          <div style={{
            fontSize: '14px',
            fontWeight: 600,
            color: '#00FFD1',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            STATUS: AUDIT PASSED [✓]
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 1024px) {
          footer {
            padding: 40px 20px !important;
          }
          .footer-grid {
            grid-template-columns: 1fr 1fr !important;
            gap: 40px !important;
          }
          .footer-grid > div:first-child {
            grid-column: 1 / -1;
          }
        }
        @media (max-width: 768px) {
          footer {
            padding: 30px 20px !important;
          }
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
          }
          .footer-grid > div:first-child {
            grid-column: 1;
          }
          .footer-bottom {
            flex-direction: column;
            align-items: flex-start !important;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;